import { ref, onMounted, computed } from 'vue';
import useKillswitches from '~/composables/useKillswitches';

const USER_CHAT_ACTIVE = 'isChatActive';

export function useAskAiVisibility() {
  const killswitches = useKillswitches();
  const isUserChatActive = ref(false);

  const isCustomerServicePage = ref(false);

  // no hydration ussue since these are csr pages only
  if (import.meta.client) {
    isCustomerServicePage.value = location?.pathname?.startsWith('/customer-service');
  }

  onMounted(() => {
    isUserChatActive.value = localStorage.getItem(USER_CHAT_ACTIVE) === 'true';
  });

  const isAiScriptEnabled = computed(() => killswitches.value?.convoCommerceEnabled && !isCustomerServicePage.value);

  const isAskAiHidden = computed(() => {
    return isUserChatActive.value || !isAiScriptEnabled.value;
  });

  return {
    isUserChatActive,
    isAskAiHidden,
    isAiScriptEnabled,
  };
}

export default useAskAiVisibility;
